import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/ValidationCheck.svg'

export const IconValidationCheck = IconSVG as IconComponent
